import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { AuthGate } from '../auth/AuthGate';
import { ErrorBoundary } from '../shared/components/ErrorBoundary';
import { persistor, store } from '../store/store';
import { AppRouter } from './Router';

const App = () => (
  <ErrorBoundary>
    <AuthGate>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppRouter />
        </PersistGate>
      </Provider>
    </AuthGate>
  </ErrorBoundary>
);

export default App;
